import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 70A0953D-9FEF-4858-8ACB-A90C5613360A
 * name table-of-contents
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/table-of-contents.svg
 * tags
 */
export const TableOfContentsIcon = createSvgIcon(<><path d="M3,9H17V7H3V9M3,13H17V11H3V13M3,17H17V15H3V17M19,17H21V15H19V17M19,7V9H21V7H19M19,13H21V11H19V13Z" /></>, 'TableOfContentsIcon');
export default TableOfContentsIcon